
import React from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TradingWidget from './components/TradingWidget';
import FeaturesSection from './components/FeaturesSection';
import HowItWorksSection from './components/HowItWorksSection';
import TrustSection from './components/TrustSection';
import AuroraCardSection from './components/AuroraCardSection';
import LendingSection from './components/LendingSection';

export default function Home() {
  return (
    <React.Fragment>
      <Header />
      <main>
        <HeroSection />
        <TradingWidget />
        <FeaturesSection />
        <HowItWorksSection />
        <AuroraCardSection />
        <LendingSection />
        <TrustSection />
      </main>
      <Footer />
    </React.Fragment>
  );
}
